export default [
  {
    name: 'type',
    label: 'group',
    type: 'goodsGroup',
    default: {},
  },
  {
    name: 'serial',
    label: 'serial',
    dictionary: 'devicestatuses',
    type: 'select',
    itemValue: 'serial',
    itemText: 'serial',
    default: {},
  },
  {
    name: 'organisation',
    label: 'last_known_place',
    dictionary: 'organization',
    type: 'select',
    itemValue: 'id',
    itemText: 'shortName',
    default: {},
  },
]
